// import { contacts } from './reducer';

function ascendingSort(contact1, contact2) {
  const name1 = contact1.name ? contact1.name.toUpperCase() : '~';
  const name2 = contact2.name ? contact2.name.toUpperCase() : '~';
  const val = name1 === name2 ? 0 : -1;
  return name1 > name2 ? 1 : val;
}

const contactActions = {
  LOAD_CONTACTS: 'LOAD_CONTACTS',
  LOAD_CONTACTS_SUCCESS: 'LOAD_CONTACTS_SUCCESS',
  LOAD_CONTACTS_ERROR: 'LOAD_CONTACTS_ERROR',
  ADD_CONTACT: 'ADD_CONTACT',
  EDIT_CONTACT: 'EDIT_CONTACT',
  DELETE__CONTACT: 'DELETE__CONTACT',
  CHANGE_CONTACT: 'CHANGE_CONTACT',
  EDIT_CONTACTS_VIEW: 'EDIT_CONTACTS_VIEW',
  changeContact: id => ({
    type: contactActions.CHANGE_CONTACT,
    id,
  }),
  loadContacts: data => ({
    type: contactActions.LOAD_CONTACTS,
    payload: data,
  }),
  addContact: newContact =>
    (dispatch, getState) => {
      dispatch({
        type: contactActions.ADD_CONTACT,
        contacts: [...getState().Contacts.get('contacts'), newContact],
        selectedId: newContact.id,
      });
    },
  editContact: newContact => (dispatch, getState) => {
    const contacts = getState().Contacts.get('contacts');
    const newContacts = [];
    contacts.forEach((contact) => {
      if (contact.id === newContact.id) {
        newContacts.push(newContact);
      } else {
        newContacts.push(contact);
      }
    });
    dispatch({
      type: contactActions.EDIT_CONTACT,
      contacts: newContacts.sort(ascendingSort),
    });
  },
  deleteContact: id => (dispatch, getState) => {
    const contacts = getState().Contacts.get('contacts');
    const selectedId = getState().Contacts.get('selectedId');
    const newContacts = [];
    contacts.forEach((contact) => {
      if (contact.id !== id) {
        newContacts.push(contact);
      }
    });
    dispatch({
      type: contactActions.DELETE__CONTACT,
      contacts: newContacts,
      selectedId: id === selectedId ? undefined : selectedId,
    });
  },
  deleteAllContacts: () => (dispatch) => {
    dispatch({
      type: contactActions.DELETE__CONTACT,
      contacts: [],
      selectedId: undefined,
    });
  },
  editContactsViewChange: view => ({
    type: contactActions.EDIT_CONTACTS_VIEW,
    view,
  }),
};
export default contactActions;



// WEBPACK FOOTER //
// ./src/redux/contacts/actions.js